export interface Address {
  4002?: string
  250: string
}

export interface Token {
  symbol: string
  address?: Address
  decimals?: number
  projectLink?: string
  usdcPrice?: string
}

export interface LpToken {
  symbol: string
  address?: Address
  decimals?: number
  projectLink?: string
  usdcPrice?: string
  token?: Token
  quoteToken?: Token
}

export interface FarmConfig {
  pid: number
  symbol: string
  addLiquidityBaseUrl?: string
  infoBaseUrl?: string
  siteUrl?: string
  address: Address
  token: Token
  quoteToken: Token
  multiplier?: string
  fee?: number
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
  isTokenOnly?: boolean
}

export interface PoolConfig {
  sousId: number
  stakingToken: Token
  isFinished?: boolean
  fee?: number
  enableEmergencyWithdraw?: boolean
}

export interface MultiPoolConfig {
  earningTokens: Token[]
  contractAddress: Address
}

export interface VaultConfig {
  vid: number
  name: string
  token: LpToken
  contractAddress: Address
  strategyAddress?: Address
  isFinished?: boolean
  earnedToken?: string
  subTitle?: string
  withdrawalFee?: string
}

export interface Currency {
  pid: number
  symbol: string
  address: Address
  decimals?: number
  projectLink?: string
  field: string
  tokenBalance?: string
  tokenPrice?: number
  allowance?: string
  token?: Token
  quoteToken?: Token
}

export type PageMeta = {
  title: string
  description?: string
  image?: string
}

export enum SeriesKey {
  FOUNDER = 'founder',
  SERIES0 = 'series0',
  SERIES1 = 'series1',
  FTG1 = 'ftg1',
  FSMC = 'fsmc',
  SERIES2 = 'series2',
  RACCOON = 'raccoon',
  WEAPONIZED = 'weaponized',
  SLURPIESBYZAQ = 'slurpiesbyzaq',
  YAMALOKA = 'yamaloka',
  CYBERSTONED = 'cyberstoned',
  STONKSSOCIETY = 'stonkssociety',
  STICK_MAN = 'stickman',
  TERRA_FORMERS = 'terraformers',
  ONE_LING = 'oneLing',
  NOVA_CHIMP = 'novachimp',
  FRENCHIES = 'frenchies',
  PHANTOM_WAVE = 'phantomwave',
  GNARWHALS = 'gnarwhals',
  CAPYS = 'capys',
  MAGIK = 'magik',
  SLOTH_AVATAR = 'slothAvatar',
  FAT_BIRDS = 'fatBirds',
  RACCOON_SNT = 'raccoonSnt',
  PAINTHUFFING = 'paintHuffing',
  BLAST1 = 'blast1',
  HAMSTERS = 'hamsters',
  SEAHORSES = 'seaHorses',
  NATIVEWARRIOR = 'nativewarrior',
  ALIENHEADS = 'alienheads',
  PUNKS = 'punks',
  RAS_TERMS = 'rasTerms',
  STARSFALL = 'starsfall',
  EDBANGERZ = 'edbangerz',
  LOVEYOUKITTENS = 'loveyoukittens',
  FANTOMNECROMANCERS = 'necromancers',
  FANTOWN = 'fantown',
  FOUNDER_V2 = 'founderV2',
  SERIES0_V2 = 'series0V2',
  MEMBERS = 'members',
  SMOKERS = 'SilhouetteSmokers',
  ALIENHEADS2D = 'alienheads2d',
  SERIES1_V2 = 'series1V2',
  FRENCHIES_V2 = 'frenchiesV2',
}

export type SeriesConfig = {
  sid: number
  key: SeriesKey
  name: string
  collectionName?: string
  description?: string
  boxType?: string
  address: Address
  pool?: Address
  dmdMaster?: Address
  isMasterChefPool?: boolean
  withoutPool?: boolean
  projectLink?: string
  preTotalSupply?: number
  notFromERC721Enumerable?: boolean
  getPriceFunc?: string
  maxSupplyFunc?: string
  notEtherPrice?: boolean
  isLaunchpad?: boolean
  image?: string
  animation?: string
  releaseDate?: string
  token?: Token
  rewardToken?: Token
  disableMint?: boolean
  minDmdBalanceToMint?: number
  nftkeyColName?: string
  paintswap?: boolean
  operaHouse?: string
  tofu?: string
  gateway?: string
  withoutMC?: boolean
  twitter?: string
  telegram?: string
  discord?: string
  abilityKey?: string
}

export type DNft = {
  nid: number
  name?: string
  description?: string
  image?: string
  animationUrl?: string
  isStaked?: boolean
  attributes?: any[]
}

export enum ApproveResponse {
  SUCCESS = 'success',
  FAIL = 'fail',
}

export interface PairTokenInfo {
  symbol: string
  amount: number
  address: string
}
